import {localDateTimeToIso} from '../craft/local-time.js';
export {localDateTimeCandidates,strictLocalDateTimeToIso,localDateTimeToIso,isoToLocalInputValue,formatPlannedDateTime} from '../craft/local-time.js';

function requiredIso(value,label){
  const text=String(value||'').trim();
  if(!text||Number.isNaN(Date.parse(text)))throw new TypeError(label+' must be an ISO timestamp');
  return text;
}

function optionalIso(value,label){
  if(value==null||value==='')return null;
  return requiredIso(value,label);
}

function durationOf(summary){
  const value=summary?.target?.plannedDurationMinutes
    ??summary?.plannedDurationMinutes
    ??null;
  if(value==null||value==='')return null;
  const number=Number(value);
  if(!Number.isInteger(number)||number<1)return null;
  return number;
}

export function createScheduleSummary({
  plannedStartAt=null,
  plannedEndAt=null,
  stageSummaries=[]
}={}){
  const start=optionalIso(plannedStartAt,'plannedStartAt');
  const end=optionalIso(plannedEndAt,'plannedEndAt');
  if(start&&end&&Date.parse(end)<Date.parse(start)){
    throw new TypeError('plannedEndAt cannot be before plannedStartAt');
  }

  const durations=(stageSummaries||[]).map(durationOf);
  const known=durations.filter(value=>value!=null);
  const total=known.reduce((sum,value)=>sum+value,0);
  const stageCount=durations.length;
  const knownCount=known.length;
  const coverage=stageCount===0||knownCount===0
    ?'none'
    :knownCount===stageCount
      ?'complete'
      :'partial';

  const windowMinutes=start&&end
    ?Math.round((Date.parse(end)-Date.parse(start))/60_000)
    :null;
  const differenceMinutes=coverage==='complete'&&windowMinutes!=null
    ?windowMinutes-total
    :null;
  const materialThresholdMinutes=coverage==='complete'&&total>0
    ?Math.max(15,Math.round(total*0.10))
    :null;
  const materialConflict=differenceMinutes!=null
    &&Math.abs(differenceMinutes)>materialThresholdMinutes;

  return Object.freeze({
    plannedStartAt:start,
    plannedEndAt:end,
    stageCount,
    stageDurationKnownCount:knownCount,
    stageDurationCoverage:coverage,
    totalStageDurationMinutes:knownCount?total:null,
    plannedWindowMinutes:windowMinutes,
    differenceMinutes,
    materialThresholdMinutes,
    materialConflict
  });
}

export function plannedSessionTimesFromForm(formData,{utcOffsetMinutes=null,timeZone=null}={}){
  if(!formData?.get)throw new TypeError('FormData-like input is required');
  const plannedStartAt=localDateTimeToIso(formData.get('plannedStart'),{utcOffsetMinutes,timeZone});
  const plannedEndAt=localDateTimeToIso(formData.get('plannedEnd'),{utcOffsetMinutes,timeZone});
  if(plannedStartAt&&plannedEndAt&&Date.parse(plannedEndAt)<Date.parse(plannedStartAt)){
    throw new TypeError('Planned end cannot be before planned start');
  }
  return Object.freeze({plannedStartAt,plannedEndAt});
}
